import React, {useEffect, useState} from 'react';
import styled from 'styled-components';
import {useSelector, useDispatch} from 'react-redux';
import {getAIChatBotIntegrationParameters} from '../../../actions/IntegrationParameters/aichatbotintegrationparametersactions';
import config from '@ey/voltron-config';
import RemoteComponent from '../../Common/ModuleFederation/RemoteComponent';
import {useEngagementId} from '../../../util/customhooks';
import {serviceURL} from '../../../util/uiconstants';
import env from '../../../util/env';
import _ from 'lodash';

export default function AIChatbot(props) {
	const {show, setShow} = props;
	const context = useSelector((state) => state.aiChatBotIntegrationParameters);
	const dispatch = useDispatch();
	const [aiChatBotPayload, setAIChatBotPayload] = useState('');
	const engagementId = useEngagementId();

	useEffect(() => {
		let url = env.getBaseURL(serviceURL, Number(engagementId)) + `IntegrationParameters`;
		let payload = getPageDetails();
		dispatch(getAIChatBotIntegrationParameters(url, payload));
	}, []);

	useEffect(() => {
		let payload = getPageDetails();
		setAIChatBotPayload(_.merge({}, payload, context));
	}, [context]);

	const toggleOrchestrator = () => {
		setShow(!show);
	};

	const getPageDetails = () => {
		return {
			pageDetails: {
				pageUrl: context?.pageDetails?.pageUrl,
				knowledgeTaskId: context?.pageDetails?.knowledgeTaskId,
				knowledgeFormId: context?.pageDetails?.knowledgeFormId
			}
		};
	};

	const OrchestratorProps = {
		onClose: toggleOrchestrator,
		envConfig: {
			// Need to check either need to put in config or will put in utility
			// host's own mechanism should be used
			HEARTBEAT_ENABLED: config.aiChatBotConfiguration.HEARTBEAT_ENABLED || 'false',
			// host's own policy should include a section
			PRIVACY_POLICY_ENABLED: config.aiChatBotConfiguration.PRIVACY_POLICY_ENABLED || 'false',
			// host's own header should cover this
			AVATAR_BUTTON_ENABLED: config.aiChatBotConfiguration.AVATAR_BUTTON_ENABLED || 'false',
			// no profiles needed, context comes dynamically
			PROFILE_SELECTOR_ENABLED: config.aiChatBotConfiguration.PROFILE_SELECTOR_ENABLED || 'false',
			// no skill selection should be allowed
			PLUGIN_OVERRIDE_TOGGLE_ENABLED: config.aiChatBotConfiguration.PLUGIN_OVERRIDE_TOGGLE_ENABLED || 'false',
			// skill usage should be limited to Atlas
			PLUGIN_OVERRIDE_DEFAULT_VALUE: config.aiChatBotConfiguration.PLUGIN_OVERRIDE_DEFAULT_VALUE || 'AtlasPlugin',
			// disclaimer should be hidden
			WARNING_PANEL_ENABLED: config.aiChatBotConfiguration.WARNING_PANEL_ENABLED || 'false',
			// no profiles needed, see above
			PROFILE_PANE_ENABLED: config.aiChatBotConfiguration.PROFILE_PANE_ENABLED || 'false',
			// no additional providers needed
			CHAT_PROVIDER_PANE_ENABLED: config.aiChatBotConfiguration.CHAT_PROVIDER_PANE_ENABLED || 'false',
			// no settings panel needed
			SETTINGS_BUTTON_ENABLED: config.aiChatBotConfiguration.SETTINGS_BUTTON_ENABLED || 'false',
			// close button enable
			CLOSE_BUTTON_ENABLED: config.aiChatBotConfiguration.CLOSE_BUTTON_ENABLED || 'true'
		},
		// fixed value - required for video insights
		dynamicInsightsGroup: config.aiChatBotConfiguration.DYNAMIC_INSIGHTS_GROUP || 'canvas',
		// preferably set this in a dynamic way - required for video insights

		style: {position: 'fixed', right: 0, height: 'calc(100vh - var(--px-56))', zIndex: 998},

		onBeforePostMessage: (payload) => {
			payload.context = aiChatBotPayload;
		},

		adConfig: {
			auth: {clientId: config.ad.auth.clientId}
		},

		dynamicInsightsKey: JSON.stringify(aiChatBotPayload)
	};

	if (env.allowDrydocks()) {
		console.log('AIChatBotIntegrationParameters', OrchestratorProps);
	}

	return (
		<StyledAIChatbot>
			<RemoteComponent className={`${!show ? 'hidden' : ''}`} id="orchestrator" {...OrchestratorProps} />
		</StyledAIChatbot>
	);
}

const StyledAIChatbot = styled.div`
	.hidden {
		display: none;
	}
`;
